import { useCallback } from "react";
import { useApi } from "src/hooks/useApi";
import { apiRequest } from "src/services/apiClient";

export type Justification = { id: string; text: string };

/** What the Begründung field needs: the numbered list, and a way to add the text just typed. */
export type JustificationList = { items: Justification[]; add?: (text: string) => Promise<boolean> };

const EMPTY: Justification[] = [];

/** The practice's saved Begründungen (`/justifications`, chapter 18), in display order — number = position + 1.
 *  `add` appends one (false when it was already there); the list reloads by itself after any change.
 *  `enabled: false` loads nothing — for members who can't create invoices. */
export function useJustifications(enabled = true) {
    const { data, loading, error } = useApi<{ items: Justification[] }>(enabled ? "/justifications" : null);
    const add = useCallback(async (text: string) => {
        const res = await apiRequest<{ added: boolean }>(
            "/justifications",
            { method: "POST", body: JSON.stringify({ text }) },
            { "Content-Type": "application/json" },
        );
        return res.added;
    }, []);
    return { items: data?.items ?? EMPTY, loading, error, add };
}
